define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"csi/xml"
], function(declare,Copy,xml) {

	return declare(Copy, {
		idOwnerRelation: "Samples",

		onCreatePopup: function(/*csi.view.Widget*/view) {
			view.defView.removeField("ProductColor");
			view.defView.removeField("ProductSize");
			this.inherited(arguments);
		},

		toWriterFields: function(/*String*/urlNode, /*csi.action.FormData?*/fd) {
			// summary: by default, reference to SRLineItem will not be copied - we want that here though
			this.inherited(arguments);
			this.m_writer.changeNode(urlNode).changeAttribute("SampleSRLineItem", xml.ATTR_REF, this.m_nodeSource.SampleSRLineItem);
		}
	});
});